import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

// Context
import { AuthProvider } from './contexts/AuthContext';

// Layouts
import LayoutPublic from './layouts/LayoutPublic';
import LayoutPrivate from './layouts/LayoutPrivate';

// Pages Públicas
import Home from './pages/public/Home';
import Contato from './pages/public/Contato';
// Pages Privadas
import DashboardPage from './pages/DashboardPage';
import Configurador from './pages/private/Configurador';
import Usuarios from './pages/private/Usuarios';
import TiposServicos from './pages/private/TiposServicos';
import Clientes from './pages/private/Clientes';
import LoginPage from './pages/auth/LoginPage';
import RegisterPage from './pages/auth/RegisterPage';
import NotFoundPage from './pages/public/NotFoundPage';
import AcessoNegado from './components/common/AcessoNegado';
import RedesSociaisPage from './pages/public/RedesSociaisPage';

// PMS (mock)
import LayoutPms from './pms/LayoutPms';
import PmsDashboard from './pms/Dashboard';
import Reservas from './pms/Reservas';
import Hospedes from './pms/Hospedes';
import Quartos from './pms/Quartos';
import Financeiro from './pms/Financeiro';
import Configuracoes from './pms/Configuracoes';
import ConfiguradorSite from './components/pms/ConfiguradorSite';

function App() {
  // Marcador de build para conferência em produção
  // Abra DevTools -> Console e verifique esta linha após o deploy
  React.useEffect(() => {
    // Atualize este texto a cada deploy para confirmar o bundle
    console.log('HADRITECH build tag:', '2025-08-21 20:20 BRT');
    // Também expõe globalmente para fácil checagem
    window.__HADRITECH_BUILD__ = '2025-08-21 20:20 BRT';
  }, []);

  return (
    <AuthProvider>
      <Routes>
        {/* Rotas Públicas com Layout Público */}
        <Route element={<LayoutPublic />}>
          <Route path="/" element={<Home />} />
          {/* Redirecionar '/inicio' para a raiz '/' */}
          <Route path="/inicio" element={<Navigate to="/" replace />} />
          <Route path="/sobre" element={<Navigate to="/" replace />} />
          <Route path="/servicos" element={<Navigate to="/" replace />} />
          <Route path="/contato" element={<Contato />} />
          {/* Blog temporariamente oculto: redireciona para a home */}
          <Route path="/blog" element={<Navigate to="/" replace />} />
          <Route path="/blog/:slug" element={<Navigate to="/" replace />} />
          <Route path="/login" element={<Navigate to="/" replace />} />
          <Route path="/acesso-interno" element={<LoginPage />} />
          <Route path="/registro" element={<RegisterPage />} />
          <Route path="/acesso-negado" element={<AcessoNegado />} />
          <Route path="/404" element={<NotFoundPage />} />
          <Route path="/redes" element={<RedesSociaisPage />} />
        </Route>

        {/* Rotas Protegidas com Layout Privado */}
        <Route element={<LayoutPrivate />}>
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/dashboard/configurador" element={<Configurador />} />
          <Route path="/dashboard/usuarios" element={<Usuarios />} />
          <Route path="/dashboard/servicos/tipos" element={<TiposServicos />} />
          <Route path="/dashboard/clientes" element={<Clientes />} />
          <Route path="/minha-conta" element={<div>Minha Conta</div>} />
        </Route>

        {/* PMS DEMO (rotas mock) - renomeado para evitar conflito com PMS real em /pms */}
        <Route element={<LayoutPrivate />}>
          <Route path="/demo-pms" element={<LayoutPms />}>
            <Route index element={<PmsDashboard />} />
            <Route path="dashboard" element={<PmsDashboard />} />
            <Route path="reservas" element={<Reservas />} />
            <Route path="hospedes" element={<Hospedes />} />
            <Route path="quartos" element={<Quartos />} />
            <Route path="financeiro" element={<Financeiro />} />
            <Route path="configuracoes" element={<Configuracoes />} />
            <Route path="configurador-site" element={<ConfiguradorSite />} />
          </Route>
        </Route>

        {/* Redirecionamentos */}
        <Route path="/area-do-cliente" element={<Navigate to="/dashboard" replace />} />
        <Route path="/configurador" element={<Navigate to="/dashboard/configurador" replace />} />
        
        {/* Rota de fallback para páginas não encontradas */}
        <Route path="*" element={<Navigate to="/404" replace />} />
      </Routes>
    </AuthProvider>
  );
}

export default App;
